import React, { Component } from 'react';
import { Container, Form, Col, Button, Table, Modal } from 'react-bootstrap';
import axios from 'axios'

import { AdminNav, RequestModal, Loading } from '../../helpers';
import {convertRiceTypeENToTH} from '../../helpers/function'
import {exportExcelDaily} from '../../helpers/functionForRequest'
class RequestMemDaily extends Component {
  constructor(props) {
    super(props);
    this.state = {
      licenseID : '',
      history  :[],
      arr : [],
      isLoading : true,
    }
  }
  componentDidMount(){
    console.log(this.props.history.location.state)
    let RequestInComplete = axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        action: 'viewAllRequestSheetInCompleteByDate',
        data: { 'timeValue': this.props.history.location.state },
      }
    )
    let RequestJobComplete = axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        action: 'viewAllRequestJobSheet',
      }
    )
    let viewAllOfficer = axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        action: 'viewAllOfficer',
      }
    )
    let viewAllCompany = axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        action: 'viewAllCompany',
      }
    )

    
    Promise.all([RequestInComplete,RequestJobComplete,viewAllOfficer,viewAllCompany])
    .then((res)=>{
      RequestInComplete = res[0].data
      RequestJobComplete = res[1].data
      viewAllOfficer = res[2].data
      viewAllCompany = res[3].data
      let arr = []
      console.log(RequestInComplete)
      if(Array.isArray(RequestInComplete)){
        Object.values(viewAllCompany).map((Company)=>{
          let id = Company['companyID'] 
          RequestInComplete.forEach((data)=>{
            if(data['companyID'] == id ){
              data['companyID']  = `${Company['companyNameEN']}`
            }
          })
        })  
      }else{
        RequestInComplete = []
      }
      
      console.log(RequestInComplete)
      this.setState({
        ...this.state,
        RequestInComplete : RequestInComplete,
        RequestJobComplete : RequestJobComplete,
        viewAllOfficer : viewAllOfficer,
        arr : RequestInComplete,
        isLoading : false,
      })
    })
  }
  renderQuantity(data,idx){
    if(data['description'][idx]['quantity']){
      return data['description'][idx]['quantity']
    }else if (data['description'][idx]['Quantity']){
      return data['description'][idx]['Quantity']
    }else {
      return null
    }
  }
  render() {
    if(!this.state.isLoading){
      return (
        <Container>
          <AdminNav></AdminNav>
          <Button variant="success" onClick={()=>{exportExcelDaily(this.state.arr)}}> Download Excel </Button>
          <Table bordered hover style={{tableLayout:'fixed',fontSize:'16px'}}>
            <thead>
              <tr>
                <th style={{width:'6.7%',overflow:'auto'}}>ลำดับ</th>
                <th style={{width:'7.7%',overflow:'auto'}}>ชื่อบริษัทส่งออก</th>
                <th style={{width:'7.7%',overflow:'auto'}}>สถานที่</th>
                <th style={{width:'6.7%',overflow:'auto'}}>เวลาบรรทุก</th>
                <th style={{width:'7.7%',overflow:'auto'}}>พนักงานตรวจข้าว / ต่อ</th>
                <th style={{width:'7.7%',overflow:'auto'}}>พนักงานตรวจข้าว / ต่อ</th> 
                <th style={{width:'7.7%',overflow:'auto'}}>ชื่อพาหนะ</th>
                <th style={{width:'7.7%',overflow:'auto'}}>ประเทศปลายทาง</th>
                <th style={{width:'10.7%',overflow:'auto'}}>เลขที่ใบอนุญาต</th>
                <th style={{width:'6.7%'}}>รายการที่</th>
                <th style={{width:'7.7%',overflow:'auto'}}>ชนิดข้าว</th>
                <th style={{width:'7.7%',overflow:'auto'}}>ปริมาณ / ตัน</th>
                <th style={{width:'7.7%',overflow:'auto'}}>ชื่อบริษัทเซอร์เวย์</th>
              </tr> 
            </thead>
            <tbody>
            {this.state.arr.map((data,idz)=>{
              if(data){
                return (Object.keys(data['description']).map((idx)=>{
                  return (<tr id={idx} > 
                    <td style={{width:'7.7%',fontSize:'12px'}}>{parseInt(idz) + 1}</td>
                    <td style={{width:'7.7%',fontSize:'12px'}}>{data['companyID']}</td>
                    <td style={{width:'7.7%',fontSize:'12px'}}>{data['surveyLocateName']} - {data['surveyDistrict']} - {data['surveyProvince']}</td>
                    <td style={{width:'7.7%',fontSize:'12px'}}>{data['shippingTime']} น.</td>
                    <td style={{width:'7.7%',fontSize:'12px'}}>{data['officerID']} {data['chainID']}</td>
                    <td style={{width:'7.7%',fontSize:'12px'}}>{data['officerID2']} {data['chainID']}</td>
                    <td style={{width:'7.7%',fontSize:'12px'}}>{data['description'][idx]['vehicleName']}</td>
                    <td style={{width:'7.7%',fontSize:'12px'}}>{data['description'][idx]['destinationCity']}</td>
                    <td style={{width:'10.7%',fontSize:'12px'}}>{data['description'][idx]['licenseID']}</td>
                    <td style={{width:'4.7%',fontSize:'12px'}}>{parseInt(data['description'][idx]['subID']) +1}</td>
                    <td style={{width:'7.7%',fontSize:'12px'}}>{convertRiceTypeENToTH(data['description'][idx]['riceTypeID'])}</td>
                    <td style={{width:'7.7%',fontSize:'12px'}}>{this.renderQuantity(data,idx)}</td>
                    <td style={{width:'7.7%',fontSize:'12px'}}>{data['description'][idx]['surveyCompany']}</td>
                  </tr>
                  )
                }))  
              }
            })}
            </tbody>
          </Table>
        </Container>
      )
    }
    else{
     return (<Container>
      <AdminNav></AdminNav>
      <Loading/>
      </Container>)
    }
  }
}
 


export default RequestMemDaily;
